import VueRouter from 'vue-router'
import routes from './routes'
import axios from 'axios'
import wx from 'weixin-js-sdk'
let loginUrl = process.env.VUE_APP_TITLE === 'production' ? window.location.origin : 'https://beta-tvshop.coocaa.com'
function beforeEach(to, from, next) {
  const isLogin = to.meta.isLogin
  const app = this.app
  const state = app.$service.state
  if (!state.inited && isLogin) {
    window.location = `${loginUrl}/cc/login.html?theme=coocaa-added-service&loginMethod=weixin,qq&redirect_to=${encodeURIComponent(window.location.href)}`
  } else {
    // 需要按照埋点的取值做转换
    let lastPageName = to.meta.title;
    // 这里需要埋点数据,获取上个页面的路由
    // 特殊情况:如果是从分享页面跳入,或者是支付成功返回,或者是触发登录后进入,此时frontPageName均为null
    if (lastPageName) {
      if(['酷开商城','我的','商品分类'].includes(lastPageName)){
        lastPageName = '首页'
      }
      let lastPageList = this.app.$store.state.lastPageList;
      let index = lastPageList.findIndex(item => item == lastPageName);
      if (index > -1) {
        lastPageList.splice(index + 1)
      } else {
        lastPageList.push(lastPageName)
      }
    }
    next(to.name !== 'login'
      ? to.matched.length === 0 && app.$router.getMatchedComponents(to.fullPath).length > 0
        ? { path: to.fullPath }
        : undefined
      : { name: '/' }
    )
  }
}
function afterEach(to, from) {
  if (window.__wxjs_is_wkwebview) { // IOS
    if (window.entryUrl === '' || window.entryUrl === undefined) {
      var url = window.location.origin + to.fullPath
      window.entryUrl = url
    }
  } else { // 安卓
    window.entryUrl = `${window.location.origin}${to.fullPath}`
  }
  let app = this.app;
  let extraList = ['商品详情','我的','购物车','商品分类','酷开商城','拼团详情','确认订单','支付成功'];
  if(!extraList.includes(to.meta.title)){
    this.app.$constants.submitccLog("partner_mini_page_show", to.meta.title, {
      // user_type: app.$store.state.vuexEmpInfo.empNo == null,
      user_empNo: app.$store.state.vuexEmpInfo.empNo || '',
      page_name:to.meta.title,
    })
  }
}

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach(beforeEach.bind(router))
router.afterEach(afterEach.bind(router))

export default router
